export default class {
	idAta
	idsDocumentosAta

	constructor(idAta, idsDocumentos) {
		this.idAta = idAta
		this.idsDocumentosAta = idsDocumentos
	}
}
